export default function formatCurrency(amount: number): string {
  const formattedAmount = amount.toLocaleString('nl-NL', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return `€ ${formattedAmount}`;
}
